import { useEffect } from "react"

export default function LoadingPage() {

    useEffect(() => {
        document.title = "Loading...";
    }, [])

    return (
        <div className="error">
        <title>loading...</title>
        <h2 id="error-notice">loading</h2>
        </div>
    )
}